module.exports = __webpack_public_path__ + "img/accessory_hat_14.49d080af.svg";